import React from "react";
import "./Switch.css";

function Switch({ isOn, handleToggle }) {
  return (
    <div className={`switch ${isOn ? "on" : "off"}`} onClick={handleToggle}>
      <span className="switch-text">ON</span>
      <div className="switch-handle"></div>
      <span className="switch-text">OFF</span>
    </div>
  );
}

export default Switch;
